import { __awaiter } from "tslib";
/**
 * 发起争议处理
 */
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { notification } from 'antd';
import Luban from '@souche-f2e/luban-js';
export default createStore({
    state: {
        callback: null,
        visible: false,
        // 处理类型
        disputeDealType: [],
        // 争议单ID
        id: '',
        // 买家是否付款
        IsBuyerPay: false,
        // 合手价
        jointPrice: 0,
        // 当前选择的处理类型
        currentSelDealType: '',
        // 减免服务费
        reduceServiceFee: 0,
        // 减免佣金
        reduceCommissionFee: 0,
        // 减免车款
        reduceCarPrice: 0,
        // 买家保证金
        buyerDepositBalance: 0,
        // 卖家保证金
        sellerDepositBalance: 0,
    },
    effects: {
        // 查询处理类型
        getDisputeDealType(val, { state }) {
            Api.base.getKeyValueListByTypeId(val).then((data) => {
                this.SET_STATE({
                    disputeDealType: data,
                });
            });
        },
        //  查询买卖家可用保证金
        getUserDepositBalance(val, { state }) {
            Api.order.getUserDepositBalance(val).then((data) => {
                this.SET_STATE({
                    buyerDepositBalance: data.buyerDepositBalanceY || 0,
                    sellerDepositBalance: data.sellerDepositBalanceY || 0,
                });
            });
        },
        // 改变处理类型
        changeOpenType(val, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                this.SET_STATE({
                    currentSelDealType: val,
                });
            });
        },
        // 提交处理结果
        confirmDispute(form, { state }) {
            form.validateFields((err, val) => {
                if (!err) {
                    const params = {
                        disputeCode: state.id,
                        disputeResult: val.disputeDealType,
                        breachPrice: val.defaultPayment,
                        reductionService: val.reduceServiceFee,
                        reductionCommission: val.reduceCommissionFee,
                        reductionCarprice: val.reduceCarPrice,
                        totalPrice: val.newJointPrice,
                        disputeRemark: val.disputeReason,
                    };
                    const apiList = ['buyerDefault', 'sellerDefault', 'tradeContinue', 'disputeTradeFailure'];
                    Api.order.submitDealDispute(apiList[Number(val.disputeDealType)], params).then((data) => {
                        this.hide();
                        Luban.send({
                            typeId: 'PSGJB-ORDER-ZYGL-ZYCL',
                            eventType: 'click',
                        });
                        notification.success({ message: '争议处理成功' });
                        state.callback && state.callback(state.id);
                    });
                }
            });
        },
        // 提交
        dealTransDetail(form, { state }) {
            form.validateFields((error, values) => {
                if (!error) {
                    const params = {
                        disputeCode: state.id,
                        disputeResult: values.disputeResult,
                        compensationPrice: values.compensationPrice,
                        disputeRemark: values.disputeRemark,
                    };
                    Api.order.dealTransDetail(params).then((data) => {
                        if (data) {
                            this.hide();
                            notification.success({ message: '操作成功' });
                        }
                        else {
                            notification.error({ message: '操作失败,请稍后重试' });
                        }
                        state.callback && state.callback(state.id);
                    });
                }
            });
        },
        // 处理争议弹窗
        showDealDisputeModal(payload) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.show(payload);
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload).forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        show(state, { id, jointPrice, IsBuyerPay, callback }) {
            if (id && jointPrice) {
                state.id = id;
                state.jointPrice = jointPrice;
                state.IsBuyerPay = IsBuyerPay !== 0;
                state.callback = callback;
                state.visible = true;
            }
            else {
                console.warn('发起争议组件必需参数id,jointPrice,IsBuyerPay请检查是否传入！');
            }
        },
        hide(state) {
            state.visible = false;
            state.id = null;
            state.IsBuyerPay = null;
            state.jointPrice = null;
            state.callback = null;
            state.currentSelDealType = null;
        },
        resetState(state) {
            state.openVal = '';
            state.disputeType = [];
        },
    },
});
